import { apis, serverCall } from "../../utils/api/constant";
import {
    setCreditManagementInputData, setCreditManagementDropDownData, setCreditManagementTableData,
    setCreditManagementUsageTableData, setCreditManagementMeterTableData, setCreditManagementAdjEntryTableData,
    isCreditManagementDataLoading
} from "./action";
import { logOut } from "../../Logout";

export const fetchCreditManagementInputData = (requestData, token) => {
    return async (dispatch, getState) => {
        if (requestData.apiID != 1) {
            dispatch(isCreditManagementDataLoading(true));
        }
        try {
            dispatch(setCreditManagementMeterTableData(null));
            dispatch(setCreditManagementUsageTableData(null));
            dispatch(setCreditManagementTableData(null));
            dispatch(setCreditManagementAdjEntryTableData(null));
            let response = await serverCall(apis.CREDIT_MANAGEMENT_GET_DATA, "POST", requestData, { "sid": token });
            dispatch(isCreditManagementDataLoading(false));
            if (response.data.pRESULT) {
                if (requestData.apiID == 1) {
                    dispatch(setCreditManagementInputData(response.data.pDATASET));
                } else if (requestData.apiID == 2) {
                    dispatch(setCreditManagementMeterTableData(response.data.pDATASET));
                    dispatch(setCreditManagementUsageTableData(response.data.pDATASET));
                } else if (requestData.apiID == 3) {
                    dispatch(setCreditManagementDropDownData(response.data.pDATASET));
                } else if (requestData.apiID == 4) {
                    dispatch(setCreditManagementTableData(response.data.pDATASET));
                } else if (requestData.apiID == 5) {
                    dispatch(setCreditManagementAdjEntryTableData(response.data.pDATASET));
                }
            } else {
                if (response?.data?.ERROR_MSG?.toUpperCase() == 'TOKEN EXPIRED') {
                    logOut(response?.data);
                } else {
                    dispatchClearTableData(dispatch, requestData.apiID);
                }
            }
        } catch (e) {
            dispatch(isCreditManagementDataLoading(false));
        }
    }
};

export const sendCrMgtAdjEntryData = (requestData, token) => {
    return async (dispatch, getState) => {
        try {
            let response = await serverCall(apis.CREDIT_MANAGEMENT_UPDATE_DATA, "POST", requestData, { "sid": token });
            if (!response?.data?.ERROR_STATUS) {
                console.log(response.data)
                logOut(response.data); // Run logout function on error
              }
            if (response.data.pRESULT) {
                alert('Data submitted successfully')
            } else {
                if (response?.data?.ERROR_MSG?.toUpperCase() == 'TOKEN EXPIRED') {
                    logOut(response?.data);
                } else {
                    alert('Error!')
                }
            }
        } catch (error) {
            alert('Error!')
        }
    };
};

export const dispatchClearTableData = (dispatch, apiID) => {
    dispatch(clearTableData(apiID));
}

export const clearTableData = (apiID) => {
    return async (dispatch, getState) => {
        if (apiID == 1) {
            dispatch(setCreditManagementInputData(null));
        } else if (apiID == 2) {
            dispatch(setCreditManagementMeterTableData(null));
            dispatch(setCreditManagementUsageTableData(null));
        } else if (apiID == 3) {
            dispatch(setCreditManagementDropDownData(null));
        } else if (apiID == 4) {
            dispatch(setCreditManagementTableData(null));
        } else if (apiID == 5) {
            dispatch(setCreditManagementAdjEntryTableData(null));
        }
    }
}